"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAdminGroupQuery = exports.adminDashboardQuery = exports.incompatibilitiesQuery = exports.slotLabelsQuery = exports.sectionSlotsQuery = exports.extendedUserReqRulesQuery = exports.userReqRuleQuery = exports.userReqRulesQuery = exports.loadUserQuery = exports.itrUsersQuery = exports.itrRolesQuery = exports.itrQuery = void 0;
var api_1 = require("../../api");
function fetchItr(id) {
    return (0, api_1.request)({ url: "manager/itrs/".concat(id), method: "get" });
}
var itrQuery = function (id) { return ({
    queryKey: ["itr", id],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchItr(id)];
    }); }); },
}); };
exports.itrQuery = itrQuery;
function fetchItrRoles(id) {
    return (0, api_1.request)({ url: "/manager/itrs/".concat(id, "/fetch_itr_roles"), method: "get" });
}
var itrRolesQuery = function (id) { return ({
    queryKey: ["itrRoles", id],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchItrRoles(id)];
    }); }); },
}); };
exports.itrRolesQuery = itrRolesQuery;
function fetchItrUsers(id) {
    return (0, api_1.request)({ url: "/manager/itrs/".concat(id, "/itr_users"), method: "get" });
}
var itrUsersQuery = function (id) { return ({
    queryKey: ["itrUsers", id],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchItrUsers(id)];
    }); }); },
}); };
exports.itrUsersQuery = itrUsersQuery;
function fetchUser() {
    return (0, api_1.request)({ url: "/load_user", method: "get" });
}
var loadUserQuery = function () { return ({
    queryKey: ["user"],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchUser()];
    }); }); },
    staleTime: Infinity,
}); };
exports.loadUserQuery = loadUserQuery;
function fetchUserReqRules(idItr) {
    return (0, api_1.request)({
        url: "/manager/itrs/".concat(idItr, "/user_req_rules"),
        method: "get",
    });
}
var userReqRulesQuery = function (idItr) { return ({
    queryKey: ["userReqRules", idItr],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchUserReqRules(idItr)];
    }); }); },
}); };
exports.userReqRulesQuery = userReqRulesQuery;
function fetchUserReqRule(idItr, idRule) {
    return (0, api_1.request)({
        url: "manager/itrs/".concat(idItr, "/user_reqs/").concat(idRule),
        method: "get",
    });
}
var userReqRuleQuery = function (idItr, idRule) { return ({
    queryKey: ["userReqRule", idRule],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchUserReqRule(idItr, idRule)];
    }); }); },
}); };
exports.userReqRuleQuery = userReqRuleQuery;
function fetchExtendedUserReqRules(idItr) {
    return (0, api_1.request)({
        url: "/manager/itrs/".concat(idItr, "/extended_user_req_rules"),
        method: "get",
    });
}
var extendedUserReqRulesQuery = function (idItr) { return ({
    queryKey: ["extendedUserReqRules", idItr],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchExtendedUserReqRules(idItr)];
    }); }); },
}); };
exports.extendedUserReqRulesQuery = extendedUserReqRulesQuery;
function fetchSectionSlots(idItr) {
    return (0, api_1.request)({
        url: "manager/itrs/".concat(idItr, "/section_slots"),
        method: "get",
    });
}
var sectionSlotsQuery = function (idItr) { return ({
    queryKey: ["sectionSlots", idItr],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchSectionSlots(idItr)];
    }); }); },
}); };
exports.sectionSlotsQuery = sectionSlotsQuery;
function fetchSlotLabels(idItr) {
    return (0, api_1.request)({
        url: "/manager/itrs/".concat(idItr, "/labels"),
        method: "get",
    });
}
var slotLabelsQuery = function (idItr) { return ({
    queryKey: ["slotLabels", idItr],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchSlotLabels(idItr)];
    }); }); },
}); };
exports.slotLabelsQuery = slotLabelsQuery;
function fetchIncompatibilities(idItr) {
    return (0, api_1.request)({
        url: "/manager/itrs/".concat(idItr, "/incompatibilities"),
        method: "get",
    });
}
var incompatibilitiesQuery = function (idItr) { return ({
    queryKey: ["incompatibilities", idItr],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchIncompatibilities(idItr)];
    }); }); },
}); };
exports.incompatibilitiesQuery = incompatibilitiesQuery;
function fetchAdminDashboard() {
    return (0, api_1.request)({ url: "/admin/fetch_manager_main_dashboard", method: "get" });
}
var adminDashboardQuery = function () { return ({
    queryKey: ["admin"],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchAdminDashboard()];
    }); }); },
}); };
exports.adminDashboardQuery = adminDashboardQuery;
function fetchAdminGroup(id_group) {
    return (0, api_1.request)({
        url: "/admin/group/".concat(id_group, "/fetch_group"),
        method: "get",
    });
}
var fetchAdminGroupQuery = function (id_group) { return ({
    queryKey: ["group", id_group],
    queryFn: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, fetchAdminGroup(id_group)];
    }); }); },
}); };
exports.fetchAdminGroupQuery = fetchAdminGroupQuery;
